import {gql} from 'apollo-angular';

export default gql`
mutation ResetPassword($input: ResetPasswordInput) {
  resetPassword(input:$input)
}
`;
